import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const DepreciationActionsToggle = ({ depreciation, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(depreciation.active ? 'actions.deactivate' : 'actions.activate')}
    color={depreciation.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={depreciation.isLoading}
    onClick={(e) => {
      e.preventDefault();
      handleClick(depreciation.id);
    }}
  />
);

export default translate()(DepreciationActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/actions/DepreciationsActionsToggle.js